import { createSlice } from "@reduxjs/toolkit";
import { getActiveTabId, getTabsStatus } from "../services/tabs";

interface TabsState {
  status: string;
  activeTabId: string;
  tabsStatus: string;
}

const initialState: TabsState = {
  status: "idle",
  activeTabId: "tab1",
  tabsStatus: "disabled",
};

const tabsSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    resetTabToCurrent: (state) => {
      state.activeTabId = "tab1"; // Resetting activeTabId to "tab1"
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveTabId, (state, action) => {
        state.activeTabId = action.payload as unknown as string;
      })
      .addCase(getTabsStatus, (state, action) => {
        state.tabsStatus = action.payload as unknown as string;
      });
  },
});
export const { resetTabToCurrent } = tabsSlice.actions;
export default tabsSlice.reducer;
